module.exports = __webpack_public_path__ + "static/image/font/pc/baemin-geullim-1.ver2_0_2.jpg?7364ae02";